import { useId } from "react";

const CadIcon = ({ width = 84, height = 81, ...props }) => {
  const uid = useId().replace(/:/g, "");
  const clipId = `cad-icon-clip-${uid}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 84 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M20 1L46.5811 1L71 25.7236V73C71 76.866 67.866 80 64 80L20 80C16.134 80 13 76.866 13 73V8C13 4.13401 16.134 1 20 1Z'
          fill='#F3F6FA'
          stroke='#D5D9DF'
          strokeWidth='2'
        />
        <path
          d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
          stroke='#D5D9DF'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <rect x='1' y='39' width='52' height='32' rx='4' fill='#344054' />
      <path
        d='M19.7364 53.4922L16.9367 53.4922C16.8856 53.13 16.7811 52.8082 16.6235 52.527C16.4658 52.2415 16.2634 51.9986 16.0162 51.7983C15.7691 51.598 15.4836 51.4446 15.1597 51.3381C14.8401 51.2315 14.4928 51.1783 14.1178 51.1783C13.4402 51.1783 12.85 51.3466 12.3472 51.6832C11.8444 52.0156 11.4544 52.5014 11.1775 53.1406C10.9005 53.7756 10.762 54.5469 10.762 55.4545C10.762 56.3878 10.9005 57.1719 11.1775 57.8068C11.4587 58.4418 11.8508 58.9212 12.3536 59.245C12.8564 59.5689 13.4381 59.7308 14.0986 59.7308C14.4694 59.7308 14.8124 59.6818 15.1277 59.5838C15.4473 59.4858 15.7307 59.343 15.9779 59.1555C16.225 58.9638 16.4296 58.7315 16.5915 58.4588C16.7577 58.1861 16.8728 57.875 16.9367 57.5256L19.7364 57.5384C19.664 58.1392 19.4829 58.7187 19.1931 59.277C18.9076 59.831 18.5219 60.3274 18.0361 60.7663C17.5546 61.201 16.9793 61.5462 16.3103 61.8018C15.6455 62.0533 14.8934 62.179 14.0539 62.179C12.8863 62.179 11.8422 61.9148 10.9218 61.3864C10.0056 60.858 9.28115 60.093 8.74848 59.0916C8.22007 58.0902 7.95587 56.8778 7.95587 55.4545C7.95587 54.027 8.22433 52.8125 8.76126 51.8111C9.2982 50.8097 10.0269 50.0469 10.9473 49.5227C11.8678 48.9943 12.9033 48.7301 14.0539 48.7301C14.8124 48.7301 15.5155 48.8366 16.1633 49.0497C16.8152 49.2628 17.3927 49.5739 17.8955 49.983C18.3983 50.3878 18.8074 50.8842 19.1228 51.4723C19.4424 52.0604 19.6469 52.7337 19.7364 53.4922ZM23.7584 62L20.7925 62L25.3117 48.9091L28.8785 48.9091L33.3912 62L30.4253 62L27.1462 51.9006L27.0439 51.9006L23.7584 62ZM23.5731 56.8544L30.5787 56.8544V59.0149L23.5731 59.0149V56.8544ZM39.6345 62L34.9939 62V48.9091L39.6729 48.9091C40.9896 48.9091 42.1231 49.1712 43.0734 49.6953C44.0237 50.2152 44.7545 50.9631 45.2659 51.9389C45.7815 52.9148 46.0393 54.0824 46.0393 55.4418C46.0393 56.8054 45.7815 57.9773 45.2659 58.9574C44.7545 59.9375 44.0195 60.6896 43.0606 61.2138C42.1061 61.7379 40.9641 62 39.6345 62ZM37.7616 59.6286L39.5195 59.6286C40.3376 59.6286 41.0258 59.4837 41.5841 59.1939C42.1466 58.8999 42.5685 58.446 42.8497 57.8324C43.1352 57.2145 43.278 56.4176 43.278 55.4418C43.278 54.4744 43.1352 53.6839 42.8497 53.0703C42.5685 52.4567 42.1487 52.005 41.5905 51.7152C41.0322 51.4254 40.344 51.2805 39.5258 51.2805L37.7616 51.2805V59.6286Z'
        fill='white'
      />
      <defs>
        <clipPath id={clipId}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CadIcon;
